import FileUploader from '@/src/components/common/FileUploader/files'
import { FormButton, ModalHeader } from '@ui'
import { getError } from '@util'
import { Box, Layer } from 'grommet'
import { Controller, FormProvider, useForm } from 'react-hook-form'

type Props = {
  onClose: () => void
  handleFile?: (file: File) => void
}
export const Upload = ({ onClose, handleFile }: Props) => {
  const methods = useForm()
  const {
    control,
    formState: { isSubmitting }
  } = methods
  const onSubmit = async (data: any) => {
    try {
      await handleFile?.(data.fileUpload)
      onClose()
    } catch (error) {
      getError(error)
    }
  }

  return (
    <FormProvider {...methods}>
      <Layer
        margin={{ vertical: '8px' }}
        modal
        onClickOutside={onClose}
        onEsc={onClose}
        position="center"
        style={{ borderRadius: '15px' }}
      >
        <form className="flex flex-col overflow-auto" onSubmit={methods.handleSubmit(onSubmit)}>
          <Box style={{ maxHeight: '88vh', width: '630px' }}>
            <ModalHeader onClose={onClose} title="Upload Consent Form" />
            <Box className="px-10 pt-16 pb-[6em]" gap={'24px'} overflow={'auto'}>
              <Controller
                control={control}
                name="fileUpload"
                render={({ field: { onChange } }) => <FileUploader onFileUpload={file => onChange(file)} />}
              />
            </Box>
          </Box>
          <FormButton isLoading={isSubmitting} onClose={onClose} />
        </form>
      </Layer>
    </FormProvider>
  )
}

export default Upload
